/**
 * common breakpoints
 * https://getbootstrap.com/docs/5.0/layout/breakpoints/
 */
const gridBreakpoints = {
  sm: 576,
  // max-width for mobiles/small devices
  md: 768,
  lg: 992
};
/**
 * This delta is to prevent two states co-existing on boundary condition.
 * for example: when screen width is of exact 768px, the small-only and medium-only
 * view would co-exist if they had same bounds.
 * therefore, to prevent we introduce 0.02px difference in them
 */

const delta = 0.02;

/**
 * Breakpoints are customizable widths that determine how your responsive
 * layout behaves across device or viewport sizes
 *
 * use this in emotion styled component like:
 * @media ${mediaBreakpoints.mediumUp} {...}
 */
export const mediaBreakpoints = {
  smallUp: "(min-width: ".concat(gridBreakpoints.sm, "px)"),
  mediumUp: "(min-width: ".concat(gridBreakpoints.md, "px)"),
  largeUp: "(min-width: ".concat(gridBreakpoints.lg, "px)"),
  smallDown: "(max-width: ".concat(gridBreakpoints.sm - delta, "px)"),
  mediumDown: "(max-width: ".concat(gridBreakpoints.md - delta, "px)"),
  largeDown: "(max-width: ".concat(gridBreakpoints.lg - delta, "px)"),
  smallOnly: "(min-width: ".concat(gridBreakpoints.sm, "px) and (max-width: ").concat(gridBreakpoints.md - delta, "px)"),
  mediumOnly: "(min-width: ".concat(gridBreakpoints.md, "px) and (max-width: ").concat(gridBreakpoints.lg - delta, "px)"),
  largeOnly: "(min-width: ".concat(gridBreakpoints.lg, "px) and (max-width: 1200px)")
};